import { render } from "./EnUnit1-1.vue?vue&type=template&id=5a5d9210&scoped=true"
import script from "./EnUnit1-1.vue?vue&type=script&lang=js"
export * from "./EnUnit1-1.vue?vue&type=script&lang=js"

import "../assets/css/en-common.css?vue&type=style&index=0&id=5a5d9210&scoped=true&lang=css"
import "../assets/css/en/Unit1-1.css?vue&type=style&index=1&id=5a5d9210&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\project\\national-museum-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a5d9210"]])

export default __exports__